window.HelpMeChooseQuestionData = [
  {
    id: 'choose-1',
    question: '1.What kind of pool do you have?',
    multiSelect: false,
    options: [
      {
        id: 'q1-A',
        text: 'In-ground pool',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-A.png',
        width: 404,
        height: 300,
        alt: 'In-ground pool',
      },
      {
        id: 'q1-B',
        text: 'Above-ground pool',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-B.png',
        width: 404,
        height: 300,
        alt: 'Above-ground pool',
      },
      {
        id: 'q1-C',
        text: 'Not sure',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Not sure',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-2',
    question: '2.Which best describes your pool layout?(Multiple answers allowed)',
    multiSelect: true,
    options: [
      {
        id: 'q2-A',
        text: 'Mostly regular and rectangular',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-A.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-B',
        text: 'Curved or freeform shape',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-B.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-C',
        text: 'Has slopes, deep ends,  or uneven transitions',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-C.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-D',
        text: 'Has steps, ledges, or shallow sun shelf',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-D.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-E',
        text: 'Not sure',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Not sure',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-3',
    question: '3.What size is your pool?',
    multiSelect: false,
    options: [
      {
        id: 'q3-A',
        text: 'Small pool up to 6 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-A.png',
        width: 404,
        height: 186,
        alt: 'Small pool',
      },
      {
        id: 'q3-B',
        text: 'Medium pool 8 × 4m,10 × 5m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-B.png',
        width: 404,
        height: 186,
        alt: 'Medium pool',
      },
      {
        id: 'q3-C',
        text: 'Large pool More than 10 m × 5 m, larger than 50 m² and smaller than 300 m²',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-C.png',
        width: 404,
        height: 186,
        alt: 'Large pool',
      },
      {
        id: 'q3-D',
        text: "I'm not sure",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-4',
    question: '4.What is your biggest cleaning challenge?',
    multiSelect: true,
    options: [
      {
        id: 'q4-A',
        text: 'Light debris',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_A.png',
        width: 404,
        height: 186,
        alt: 'Light debris',
      },
      {
        id: 'q4-B',
        text: 'Heavy leaves / sand / algae / fine particles',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_B.png',
        width: 404,
        height: 186,
        alt: 'Heavy leaves',
      },
      {
        id: 'q4-C',
        text: "Hard-to-reach areas",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_C.png',
        width: 404,
        height: 186,
        alt: 'Hard-to-reach areas',
      },
      {
        id: 'q4-D',
        text: "I'm not sure",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-5',
    question: '5.Which sounds most like you?',
    multiSelect: false,
    options: [
      {
        id: 'q5-A',
        text: 'I want strongest cleaning automation',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_A.png',
        width: 404,
        height: 186,
        alt: 'Affordable option',
      },
      {
        id: 'q5-B',
        text: 'I want complete cleaning performance',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_C.png',
        width: 404,
        height: 186,
        alt: 'Balanced option',
      },
      {
        id: 'q5-C',
        text: 'I want the most advanced cleaning experience',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_B.png',
        width: 404,
        height: 186,
        alt: 'Strong performance',
      },
      {
        id: 'q5-D',
        text: 'I want the easiest day-to-day maintenance',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/5D.png',
        width: 404,
        height: 186,
        alt: 'Top model',
      },
    ],
  },
];
